import type { IPlainObject } from "app/pages/sales-intelligence/types/plainObject";

import type { FilterGroupDefinition } from "../../types/filterDefinition";
import type { SearchFilterInstance } from "../../types/searchFilterInstance";

export type DefineFilterGroupInput<
    TValues extends IPlainObject,
    TApiCategory extends string,
    TCtx,
    TDataSource extends string,
    TCapability extends string,
> = Omit<FilterGroupDefinition<TValues, TApiCategory, TCtx, TDataSource, TCapability>, "build"> & {
    /** The members, each carrying its own identity; `undefined` is a veto, an empty array a group with no members. */
    readonly render: (ctx: TCtx) => readonly SearchFilterInstance<TValues, TApiCategory>[] | undefined;
};

/**
 * Authors a {@link FilterGroupDefinition}. Unlike {@link defineFilter} it injects no identity: a group's
 * members are self-identified, and the group's own `key` is an order anchor rather than a DTO key.
 */
export const defineFilterGroup = <
    TValues extends IPlainObject,
    TApiCategory extends string,
    TCtx,
    TDataSource extends string,
    TCapability extends string,
>({
    render,
    ...identity
}: DefineFilterGroupInput<TValues, TApiCategory, TCtx, TDataSource, TCapability>): FilterGroupDefinition<
    TValues,
    TApiCategory,
    TCtx,
    TDataSource,
    TCapability
> => ({ ...identity, build: render });
